import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=3ca731d1&scoped=true"
var script = {}
import style0 from "./Suspended.vue?vue&type=style&index=0&id=3ca731d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca731d1",
  null
  
)

export default component.exports